const layout = {
  gutter: 20,
  width: 1195
};

export default layout;
